import React, { useMemo } from 'react';
import { useBoardData } from '../../context/BoardContext';
import { useFilters } from '../../context/FilterContext';
import { useBoardSection } from 'modules/TasksV2/context';
import TableContent from './Table/TableContent';

const AgendaView = ({ currentView }) => {
  const { taskStages } = useBoardData();
  const filters = useFilters();
  const { caseDetails } = useBoardSection();

  // Build filter object for columns - memoized to prevent breaking child memoization
  // This is identical to KanbanBoard filter params to ensure consistent data
  const filterParams = useMemo(
    () => ({
      searchKeyword: filters.searchKeyword,
      practiceArea: filters.practiceArea,
      assignedTo: filters.assignedTo,
      sortType: filters.sortType,
      dateFilter: filters.dateFilter,
      priority: filters.priority,
      case_id: caseDetails?.case_id || undefined,
    }),
    [
      filters.searchKeyword,
      filters.practiceArea,
      filters.assignedTo,
      filters.sortType,
      filters.dateFilter,
      filters.priority,
      caseDetails?.case_id,
    ]
  );

  return (
    <div className="agenda-view">
      {taskStages?.map((stage, index) => (
        <TableContent
          key={stage?.task_stage_id}
          stage={stage}
          index={index}
          filters={filterParams}
          taskStages={taskStages}
          caseDetails={caseDetails}
          currentView={currentView}
        />
      ))}
    </div>
  );
};

export default React.memo(AgendaView);
